import axios from "axios";
import FintreeConfig from "@/app/config";

const API_BASE = `${FintreeConfig.baseAPIEndpoint}/v1`;
const AUTH_BASE = `${API_BASE}/auth`;

export type LoginResult = "signed-in" | "password-setup-required";

class AuthService {
  async checkAuthStatus(): Promise<boolean> {
    try {
      const response = await axios.get(`${AUTH_BASE}/status`, { withCredentials: true });
      return response.data?.data?.authenticated === true;
    } catch {
      return false;
    }
  }

  async login(email: string, password: string): Promise<LoginResult> {
    try {
      await axios.post(`${API_BASE}/login`, { email, password }, { withCredentials: true });
      return "signed-in";
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 409) {
        return "password-setup-required";
      }
      throw error;
    }
  }

  async forgotPassword(email: string): Promise<void> {
    await axios.post(`${AUTH_BASE}/forgot-password`, { email }, { withCredentials: true });
  }

  async resetPassword(token: string, password: string): Promise<void> {
    await axios.post(`${AUTH_BASE}/reset-password`, { token, password }, { withCredentials: true });
  }

  async logout(): Promise<void> {
    try {
      await axios.post(`${AUTH_BASE}/logout`, {}, { withCredentials: true });
    } catch {
      // ignore logout errors
    }
  }
}

export const authService = new AuthService();
